export default __webpack_public_path__ + "static/media/(56).22c8fc13.jpg";